export type ProductCategoryCard = {
  label: string;
  url: string;
  image: string;
};

const PRODUCT_CATEGORIES_BY_COLLECTION = {
  moisturizer: {
    basePath: '/collections/moisturizer',
    items: [
      {
        label: 'Essence & Serum',
        path: 'essence-serum-ampoule',
        image: 'https://skin-seoul.com/wp-content/uploads/2025/02/thu_100004755_1-1.webp',
      },
      {
        label: 'Multi-Balm & Stick',
        path: 'multi-balm-stick',
        image: 'https://skin-seoul.com/wp-content/uploads/2025/02/thu_100005074_1-1.webp',
      },
      {
        label: 'Toner',
        path: 'toner',
        image: 'https://skin-seoul.com/wp-content/uploads/2024/05/thu_100006996_1-1.webp',
      },
      {
        label: 'Facial Cream',
        path: 'facial-cream',
        image: 'https://skin-seoul.com/wp-content/uploads/2025/02/thu_100004668_1-1.webp',
      },
    ],
  },
  cleanser: {
    basePath: '/collections/cleanser',
    items: [
      {
        label: 'Cleansing Foam',
        path: 'cleansing-foam',
        image: 'https://skin-seoul.com/wp-content/uploads/2025/02/thu_100004626_1-1.webp',
      },
      {
        label: 'Cleansing Oil',
        path: 'cleansing-oil',
        image: 'https://skin-seoul.com/wp-content/uploads/2025/02/XXL_p0211190448.webp',
      },
      {
        label: 'Cleansing Gel & Powder',
        path: 'cleansing-gel-powder',
        image: 'https://skin-seoul.com/wp-content/uploads/2024/05/thu_100004981_1-1.webp',
      },
      {
        label: 'Powder & Scrub',
        path: 'scrub-peeling/powder-scrub',
        image: 'https://skin-seoul.com/wp-content/uploads/2025/02/thu_100004853_1-1.webp',
      },
    ],
  },
  mask: {
    basePath: '/collections/mask-pack',
    items: [
      {
        label: 'Sheet Mask',
        path: 'sheet-mask',
        image: 'https://skin-seoul.com/wp-content/uploads/2024/05/thu_100002356_1-1.webp',
      },
      {
        label: 'Toner Pads',
        path: 'toner-pads',
        image: 'https://skin-seoul.com/wp-content/uploads/2025/02/thu_100004983_1-1.webp',
      },
      {
        label: 'Wash-Off Mask',
        path: 'wash-off-mask',
        image: 'https://skin-seoul.com/wp-content/uploads/2024/05/thu_100002163_1-1.webp',
      },
    ],
  },
  sunCare: {
    basePath: '/collections/sun-care',
    items: [
      {
        label: 'Sun Screen',
        path: 'sun-screen',
        image:
          'https://skin-seoul.com/wp-content/uploads/2025/02/round-lab-birch-juice-moisturizing-sun-cream-50ml_1024x1024.webp',
      },
    ],
  },
};

const createProductCategoryCards = (): ProductCategoryCard[] => {
  return Object.values(PRODUCT_CATEGORIES_BY_COLLECTION).flatMap(({ basePath, items }) =>
    items.map(({ label, path, image }) => ({
      label,
      url: `${basePath}/${path}/`,
      image,
    })),
  );
};

export const PRODUCT_CATEGORY_CARDS: ProductCategoryCard[] = createProductCategoryCards();
